"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/esnext.iterator.map.js");
var _react = _interopRequireDefault(require("react"));
var _svbReactComponents = require("@svb/svb-react-components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/*
 * SVB Footer
 * <SVBFooter footerContent={footerJSON} />
 */

/**
 * SVBFooter
 * @param footerContent: json array of footer-link objs
 * see ../readme.MD for sample body
 * @param fixed: to set fixed-bottom
 * @param extraClasses: additional styling classes
 * @returns footer HTML with content
 */

const SVBFooter = _ref => {
  let {
    footerContent,
    fixed,
    extraClasses
  } = _ref;
  // If fixed prop exists, we set it.
  // Otherwise, static by default.
  const typeClass = fixed ? 'fixed-bottom' : '';
  const extClasses = extraClasses ? extraClasses : '';
  // svb-footer needs to be applied by default, any other additional classes
  // are added before render
  const Classes = typeClass + ' svb-footer ' + extClasses;
  return /*#__PURE__*/_react.default.createElement("footer", {
    className: Classes
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "list svb-footer-links"
  }, footerContent && footerContent.map((footerItem, i) =>
  /*#__PURE__*/
  // Applying key to outer react.fragment
  _react.default.createElement(_react.default.Fragment, {
    key: i
  }, /*#__PURE__*/_react.default.createElement("li", {
    className: "footer-link-item"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: footerItem.link,
    title: footerItem.description ? footerItem.description : '',
    className: "footer-link"
  }, footerItem.name)), i < footerContent.length - 1 && '|'))), /*#__PURE__*/_react.default.createElement(_svbReactComponents.SVBTypography, {
    type: "paragraph",
    variant: "x-small medium footer-text"
  }, "\xA9 ", new Date().getFullYear(), " SVB Financial Group. All rights reserved. Silicon Valley Bank is a member of the FDIC and the Federal Reserve System."));
};
var _default = exports.default = SVBFooter;